import React from "react";
import DragableAndResizer from "../../components/DragableAndResizer/DragableAndResizer";
import Header from "./components/Header";
import HelpSideContent from "../../components/HelpSideContent/HelpSideContent";

import "./faq-dragabl-and-resizer.styles.css";
import { useSelector } from "react-redux";

const FaqDragableAndResizer = () => {
  const isOpenFaqDragable = useSelector(
    (state) => state.isOpenFaqDragableReducer
  );
  return (
    <DragableAndResizer signalToResetPosition={isOpenFaqDragable.signal}>
      <div className="faq-dragabl-and-resizer-container">
        <Header />
        <div className="faq-dragabl-and-resizer-container__help-side-content-container">
          <HelpSideContent isToShare={false} />
        </div>
      </div>
    </DragableAndResizer>
  );
};

export default React.memo(FaqDragableAndResizer);
